module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-modal_wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "ui-modal",
    class: {
      ui_modal_phone: !this.tools.size.isDesktop(), ui_modal_resize: _vm.modalSettings.isResize
    },
    attrs: {
      "id": _vm.config.name
    }
  }, [(_vm.modalSettings.isShowHeader) ? _c('Header', {
    staticClass: "ui-modal_header",
    attrs: {
      "slot-component": _vm.header.component,
      "slot-props": _vm.header.propsData,
      "title": _vm.modalSettings.title
    },
    on: {
      "close": _vm.close,
      "mousedown": function($event) {
        $event.stopPropagation();
        return _vm.startDrag($event)
      }
    }
  }) : _vm._e(), _c('Body', {
    staticClass: "ui-modal_body",
    attrs: {
      "slot-component": _vm.body.component,
      "slot-props": _vm.body.propsData,
      "text": _vm.modalSettings.text
    }
  }), (_vm.modalSettings.isShowFooter) ? _c('Footer', {
    staticClass: "ui-modal_footer",
    attrs: {
      "slot-component": _vm.footer.component,
      "slot-props": _vm.footer.propsData
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1edb20ea","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppModal/AppModal.vue
// module id = de3afe5a7ce12ed208e2
// module chunks = 89